<template>
  <div id="pers-tab2" name="hrms32e-tab2" class="content-pers">
    <hrms32e-tab2-tab1 class="animate-option animated" v-show="subPage === 1" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :allLang="allLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :labels="labels"
      :labelsButton="labelsButton"
      :dropdowns="dropdowns"
      :detail="detail.tab1"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab1Save="postDetail2Tab1Save"
      :searchDetail="searchDetail"
      :searchIndex="searchIndex" />

    <hrms32e-tab2-tab2 class="animate-option animated" v-show="subPage === 2" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"     
      :labels="labels"
      :labelsButton="labelsButton"
      :dropdowns="dropdowns"
      :detail="detail.tab2"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab2Save="postDetail2Tab2Save"
      :searchDetail="searchDetail"
      :searchIndex="searchIndex" />

    <hrms32e-tab2-tab3 class="animate-option animated" v-show="subPage === 3" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr" 
      :labels="labels"
      :labelsButton="labelsButton"
      :dropdowns="dropdowns"
      :detail="detail.tab3"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab3Save="postDetail2Tab3Save"
      :searchDetail="searchDetail"
      :searchIndex="searchIndex" />

    <hrms32e-tab2-tab4 class="animate-option animated" v-show="subPage === 4" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :labels="labels"
      :labelsButton="labelsButton"
      :dropdowns="dropdowns"
      :detail="detail.tab4"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab4Save="postDetail2Tab4Save"
      :searchDetail="searchDetail"
      :searchIndex="searchIndex" />

    <hrms32e-tab2-tab5 class="animate-option animated" v-show="subPage === 5" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :labels="labels"
      :labelsButton="labelsButton"
      :dropdowns="dropdowns"
      :detail="detail.tab5"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab5Save="postDetail2Tab5Save"
      :searchDetail="searchDetail"
      :searchIndex="searchIndex" />

    <hrms32e-tab2-tab6 class="animate-option animated" v-show="subPage === 6" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :labels="labels"
      :labelsButton="labelsButton"
      :detail="detail.tab6"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab6Save="postDetail2Tab6Save"
      :searchDetail="searchDetail"
      :searchIndex="searchIndex" />
      
    <hrms32e-tab2-tab7 class="animate-option animated" v-show="subPage === 7" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
      :nowLang="nowLang"
      :indexSelected="indexSelected"
      :validateStaappr="validateStaappr"
      :detail2Tab7Table="detail2Tab7Table"
      :labels="labels"
      :labelsButton="labelsButton"
      :deleteDocuments="deleteDocuments"
      :dropdowns="dropdowns"
      :detail="detail.tab7"
      :pcDisp="pcDisp"
      :togglePage="togglePage"
      :toggleSubPage="toggleSubPage"
      :triggerSubButton="triggerSubButton"
      :postDetail2Tab7Save="postDetail2Tab7Save"
      :searchDetail="searchDetail"
      :searchIndex="searchIndex"
      :personalDataActive="personalDataActive" />
     
  </div>
</template>

<script>
import hrms32eTab2Tab1 from 'components/hrms32e/tab2_1'
import hrms32eTab2Tab2 from 'components/hrms32e/tab2_2'
import hrms32eTab2Tab3 from 'components/hrms32e/tab2_3'
import hrms32eTab2Tab4 from 'components/hrms32e/tab2_4'
import hrms32eTab2Tab5 from 'components/hrms32e/tab2_5'
import hrms32eTab2Tab6 from 'components/hrms32e/tab2_6'
import hrms32eTab2Tab7 from 'components/hrms32e/tab2_7'

export default {
  name: 'hrms32e-tab2',
  props: [ 'nowLang',
    'allLang',
    'labels',
    'dropdowns',
    'detail',
    'pcDisp',
    'togglePage',
    'indexSelected',
    'labelsButton',
    'subPage',
    'deleteDocuments',
    'detail2Tab7Table',
    'postDetail2Tab1Save',
    'postDetail2Tab2Save',
    'postDetail2Tab3Save',
    'postDetail2Tab4Save',
    'postDetail2Tab5Save',
    'postDetail2Tab6Save',
    'postDetail2Tab7Save',
    'searchDetail',
    'personalDataActive',
    'searchIndex',
    'validateStaappr'
  ],
  components: {
    hrms32eTab2Tab1,
    hrms32eTab2Tab2,
    hrms32eTab2Tab3,
    hrms32eTab2Tab4,
    hrms32eTab2Tab5,
    hrms32eTab2Tab6,
    hrms32eTab2Tab7
  }
}
</script>


// WEBPACK FOOTER //
// tab2.vue?5272e797